var React = require('react');

function ConfettiImg3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.9256 16.0826L0.275635 0.944336L16.8596 5.73209L4.9256 16.0826Z","fill":"#B981F2"}));
}

ConfettiImg3.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = ConfettiImg3;

ConfettiImg3.default = ConfettiImg3;
